<template>
  <div style="margin: 50px">
    <!--element which is going to render the Card-->
    <div tabindex="0" class="e-card" id="basic">
      <div class="e-card-title">FOIP Disclosure</div>
      <div class="e-card-separator"></div>
      <div class="e-card-content margin-color-verify-section">
        <form class="login" @submit.prevent="submitFOIP">
          <div>
            <p style="text-align: justify" v-html="foipStaticMessage"></p>
          </div>
          <div class="align-right">
            <ejs-checkbox
              label="I agree"
              v-model="isIAgree"
              :checked="isIAgree"
            >
            </ejs-checkbox>
            <span style="color: red; display: block; margin-bottom: 2%">
              {{ loginErorrMessage }}
            </span>
          </div>
          <div class="align-right">
            <ejs-button
              type="button"
              cssClass="e-danger margin-button"
              v-on:click.native="onCancelClick"
            >
              Cancel
            </ejs-button>
            <ejs-button type="submit" cssClass="e-info margin-button"
              >Continue</ejs-button
            >
          </div>
        </form>
        <div ref="spinnerEle" id="spinner"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { createSpinner, showSpinner } from '@syncfusion/ej2-vue-popups';
import { STATIC_MESSAGE } from '../store';

export default {
  name: 'FoipStatement',
  props: {
    // userProfileId: String,
    // userProfilesData: Object,
  },
  mounted() {
    createSpinner({ target: this.$refs.spinnerEle });
    showSpinner(this.$refs.spinnerEle);
    this.getFOIPStaticMessage();
  },
  data() {
    return {
      isIAgree: false, // this field for 'I Agree' checkbox only
      loginErorrMessage: null,
      foipStaticMessage: null,
    };
  },
  methods: {
    async getFOIPStaticMessage() {
      try {
        const messageType = 'foip';
        await this.$store.dispatch(STATIC_MESSAGE, { messageType });
        this.foipStaticMessage = this.$store.getters.staticMessage;
        this.$refs.spinnerEle.style.display = 'none';
      } catch (err) {
        this.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content:
            'Oops, Something went wrong. We are working on getting this fixed as soon as we can. You may be able to try again shortly. If you continue to experience this issue, you can contact ASCA Tanks at ascatanks@safetycodes.ab.ca or by calling 1-888-413-0099',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        if (this.$parent.$parent.notificationToasts.length > 0) {
          this.$parent.$parent.$refs.notifierRef.show();
        }
      }
    },
    async submitFOIP() {
      // this.$parent.$parent.notificationToasts.length = 0;
      if (this.isIAgree) {
        this.$emit('FOIPVisible', this.isIAgree);
      } else {
        // to triger validation indicator for initially empty field
        this.loginErorrMessage = 'Please check "I Agree" box if you want to proceed.';
        this.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Please check "I Agree" box if you want to proceed.',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },
    onCancelClick() {
      this.$router.push('/');
    },
  },
};
</script>

<style>
@import "../../../assets/styles/eservices-base.css";

#loader {
  color: #008cff;
  height: 40px;
  left: 45%;
  position: absolute;
  top: 45%;
  width: 30%;
}
</style>
